var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 74 74",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.221,32.52a1,1,0,0,1-.9-.553l-1.3-2.6a1,1,0,1,1,1.789-.894l1.3,2.6a1,1,0,0,1-.893,1.447Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.98,72H11.02A9.019,9.019,0,0,1,2.955,58.943L28.936,6.983a9.015,9.015,0,0,1,16.128,0l7.611,15.23a1,1,0,1,1-1.789.894L43.275,7.877a7.015,7.015,0,0,0-12.55,0L4.744,59.837A7.019,7.019,0,0,0,11.02,70H62.98a7.019,7.019,0,0,0,6.276-10.163l-6.341-12.69a1,1,0,0,1,1.789-.894l6.341,12.69A9.019,9.019,0,0,1,62.98,72Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.681,41.45a1,1,0,0,1-.9-.554l-1.33-2.67a1,1,0,0,1,1.791-.892L61.575,40a1,1,0,0,1-.894,1.446Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37,48a3.943,3.943,0,0,1-3.938-3.938V27.938a3.938,3.938,0,0,1,7.876,0V44.062A3.943,3.943,0,0,1,37,48Zm0-22a1.94,1.94,0,0,0-1.938,1.938V44.062a1.938,1.938,0,0,0,3.876,0V27.938A1.94,1.94,0,0,0,37,26Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37,60.228a4.438,4.438,0,1,1,4.438-4.438A4.443,4.443,0,0,1,37,60.228Zm0-6.875a2.438,2.438,0,1,0,2.438,2.437A2.44,2.44,0,0,0,37,53.353Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.c56337f8.svg";
export { ForwardRef as ReactComponent };